import type { CustomOption, CustomOptionValue } from "core/catalog";
import { SelectInput } from "~/design-system/components/form/SelectInput";
import type { Option } from "~/design-system/types";
import { CustomOptionLabel } from "./CustomOptionLabel";
import { OptionValueRow } from "./OptionValueRow";

type SelectInputOptionProps = {
  customOption: CustomOption;
  onChange?: (value: string | string[]) => void;
};

function getOptionLabel(value: CustomOptionValue) {
  return <OptionValueRow value={value} />;
}

export function SelectInputOption({
  customOption,
  onChange,
}: SelectInputOptionProps) {
  const options = (customOption.values?.map((value) => ({
    label: getOptionLabel(value),
    value: String(value.id),
  })) || []) as Option[];

  const isMultiple = customOption.type === "multiSelect"; // Left like that for future changes.

  const defaultOption =
    customOption.values &&
    customOption.values?.find(
      (option) => option.id === customOption.defaultValue,
    )?.name;

  return (
    <SelectInput
      name={customOption.id}
      label={<CustomOptionLabel customOption={customOption} />}
      options={options}
      multiple={isMultiple}
      placeholder={
        defaultOption || customOption.description || "Select an option"
      }
      defaultValue={customOption.defaultValue}
      onChange={onChange}
      classes={{
        wrapper: "w-full",
        input: "bg-white p-3",
        selectedOption: "py-1 px-2 border border-black",
        label: "w-fit",
      }}
    />
  );
}
